import ProductServiceCls from './ProductService'
import CategoryServiceCls from './CategoryService'
// import OfferServiceCls from './OfferService'
import PostServiceCls from './PostService'
import UserPostCompletionServiceCls from './UserPostCompletionService'
import UserPurchaseServiceCls from './UserPurchaseService'
import UserProductTrackingServiceCls from './UserProductTrackingService'
// import PostMaterialServiceCls from './PostMaterialService'
// import UpsellOfferServiceCls from './UpsellOfferService'
// import VideoServiceCls from './VideoService'
// import OfferCustomizationServiceCls from './OfferCustomizationService'
// import ProductCustomizationCls from './ProductCustomizationService'
import MediaUploadServiceCls from './MediaUploadService'

let ProductService: ProductServiceCls
let CategoryService: CategoryServiceCls
// let OfferService: OfferServiceCls
let PostService: PostServiceCls
// let PostMaterialService: PostMaterialServiceCls
// let UpsellOfferService: UpsellOfferServiceCls
// let VideoService: VideoServiceCls
let MediaUploadService: MediaUploadServiceCls
// let OfferCustomizationService: OfferCustomizationServiceCls
// let ProductCustomizationService: ProductCustomizationCls
let UserPostCompletionService: UserPostCompletionServiceCls
let UserPurchaseService: UserPurchaseServiceCls
let UserProductTrackingService: UserProductTrackingServiceCls

let userId: string
let contactId: string

export function initialize(locationId: string) {
  ProductService = new ProductServiceCls(locationId)
  CategoryService = new CategoryServiceCls(locationId)
  // OfferService = new OfferServiceCls(locationId)
  PostService = new PostServiceCls(locationId)
  UserPostCompletionService = new UserPostCompletionServiceCls(locationId)
  UserPurchaseService = new UserPurchaseServiceCls(locationId)
  UserProductTrackingService = new UserProductTrackingServiceCls(locationId)
  // PostMaterialService = new PostMaterialServiceCls(locationId)
  // UpsellOfferService = new UpsellOfferServiceCls(locationId)
  // VideoService = new VideoServiceCls(locationId)
  MediaUploadService = new MediaUploadServiceCls(locationId)
  // OfferCustomizationService = new OfferCustomizationServiceCls(locationId)
  // ProductCustomizationService = new ProductCustomizationCls(locationId)
}

export function saveUserId(_userId: string) {
  userId = _userId
}

export function getUserId() {
  return userId
}

export function saveContactId(_contactId: string) {
  contactId = _contactId
}

export function getContactId() {
  return contactId
}

export {
  ProductService,
  CategoryService,
  PostService,
  UserPostCompletionService,
  UserPurchaseService,
  UserProductTrackingService,
  // OfferService,
  // PostMaterialService,
  // UpsellOfferService,
  // VideoService,
  MediaUploadService
  // OfferCustomizationService,
  // ProductCustomizationService
}
